<template>
    <div>
      <el-row class="mainHead">
        <el-col style="textAlign:right">
          <div class="newAdd">
            <slot></slot>
          </div>
        </el-col>
      </el-row>
    </div>
</template>

<script>
export default {
    data() {
      return {

      };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped lang="scss">
  .mainHead{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    .newAdd{
      background: #fff;
      padding: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// mainHead.vue?25fb2e84